/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_FormatInputs */



/**
* | output |
* | --- |
* | "Auto Format" |
*
* @param {Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format = /** @type {((inputs?: Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Auto-formatage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоформатирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो फॉर्मेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação automática")
	return /** @type {LocalizedString} */ ("Auto Format")
});